<template>
    <div class="md-layout md-gutter">
        <div class="md-layout-item">
            <md-card>
                <md-card-header>
                    <md-tabs class="md-primary tab-overwrite" md-sync-route
                             :key="'org-edit-tabs-' + (isUpdateMode ? String($route.params.id) : 'create') + '-' + federationTabRenderKey">
                        <md-tab id="tab-general" md-label="General" md-icon="store" :to="generalUrl">
                            <organization-tab-general v-model="organization" :settings="settings" :options="options" :is-update-mode="isUpdateMode"/>
                        </md-tab>
                        <md-tab id="tab-academy" md-label="Academy" md-icon="" :to="academyUrl">
                            <organization-tab-academy v-model="academy" :options="options"/>
                        </md-tab>
                        <md-tab v-if="isUpdateMode" id="tab-federation" md-label="Federation" md-icon="vpn_key" :to="federationUrl">
                            <organization-tab-federation ref="organizationFederationRef" @federation-toolbar="onFederationToolbar"/>
                        </md-tab>
                        <md-tab
                            v-if="federatedUsersTabVisible"
                            id="tab-federation-users"
                            md-label="Federated Users"
                            md-icon="import_contacts"
                            :to="federatedUsersTabTo"
                            :md-disabled="!isUpdateMode"
                        >
                            <organization-tab-federation-users v-if="isUpdateMode"/>
                        </md-tab>
                    </md-tabs>
                </md-card-header>
                <md-card-content v-if="showFederationToolbarFooter">
                    <div class="user-update-actions">
                        <template v-if="federationToolbar.credentialsPending">
                            <md-button
                                class="md-primary"
                                :disabled="federationToolbar.saving"
                                @click="onFederationUpdateClick"
                            >Save configuration</md-button>
                        </template>
                        <template v-else>
                            <md-button
                                v-if="!federationToolbar.isEditing"
                                class="md-primary"
                                @click="onFederationEditClick"
                            >Edit</md-button>
                            <template v-else>
                                <md-button class="md-simple" @click="onFederationCancelClick">Cancel</md-button>
                                <md-button
                                    class="md-primary"
                                    :disabled="federationToolbar.saving"
                                    @click="onFederationUpdateClick"
                                >Update</md-button>
                            </template>
                        </template>
                    </div>
                </md-card-content>
                <md-card-content v-if="showOrganizationSaveFooter">
                    <div class="user-update-actions">
                        <md-button class="md-simple" @click.native="actionCancel">{{ $t('Cancel') }}</md-button>

                        <md-button class="md-primary" @click="actionSave">{{createOrUpdateText}}
                        </md-button>
                    </div>
                </md-card-content>
            </md-card>
        </div>
        <delete-prompt-modal @cancel="onCancel" @confirmation="actionDelete" :name="organization.name" :show-modal="settings.showDeleteModal"/>
    </div>
</template>

<script>
    import {mapMutations} from 'vuex'
    import OrganizationTabGeneral from './OrganizationTabGeneral'
    import OrganizationTabAcademy from './OrganizationTabAcademy'
    import OrganizationTabFederation from './OrganizationTabFederation'
    import OrganizationTabFederationUsers from './OrganizationTabFederationUsers'
    import DeletePromptModal from "../../modals/DeletePromptModal";
    import { setEntityEditDocumentTitle } from '@/js/routeTitle';

    export default {
        name: "OrganizationCreate",
        components: {DeletePromptModal, OrganizationTabGeneral, OrganizationTabAcademy, OrganizationTabFederation, OrganizationTabFederationUsers},
        computed: {
            pageTitle() {
                return this.isUpdateMode ? 'Edit organization' : 'Create organization';
            },
            createOrUpdateText(){
                return this.isUpdateMode? 'Update':'Create';
            },
            generalUrl(){
                return this.isUpdateMode ?
                    '/organization/' + this.$route.params.id +'/general' : '/organization/create/general';
            },
            academyUrl(){
                return this.isUpdateMode ?
                    '/organization/' + this.$route.params.id + '/academy': '/organization/create/academy';
            },
            federationUrl(){
                return '/organization/' + this.$route.params.id + '/federation';
            },
            federatedUsersTabTo(){
                return this.isUpdateMode
                    ? '/organization/' + this.$route.params.id + '/federation-users'
                    : this.generalUrl;
            },
            federatedUsersTabVisible() {
                return this.isUpdateMode
                    && this.federationSummary.loaded
                    && this.federationSummary.hasProvider
                    && this.federationSummary.credentialsComplete
                    && this.federationSummary.enabled;
            },
            federationTabRenderKey() {
                return this.federatedUsersTabVisible ? 'with-fu' : 'no-fu';
            },
            isUpdateMode(){
                return this.$route.params.id !== undefined;
            },
            /** General/Academy: org-level save bar; Federation uses separate footer (showFederationToolbarFooter). */
            showOrganizationSaveFooter() {
                const tab = this.$route.params.tab;
                if (tab === 'federation' || tab === 'federation-users') {
                    return false;
                }
                return true;
            },
            showFederationToolbarFooter() {
                const tab = this.$route.params.tab;
                if (tab !== 'federation' || !this.isUpdateMode) {
                    return false;
                }
                return this.federationToolbar.hasProvider && !this.federationToolbar.loading;
            },
        },
        data() {
            return {
                options: {
                    resellers: [],
                    modules: [],
                    user: [],
                },
                settings: {
                    radioButtons: [
                        {label: 'Normal', id: 'normal'},
                        {label: 'Mini', id: 'mini'},
                        {label: 'Slim', id: 'slim'}
                    ],
                    loadingOrganization: true,
                    showDeleteModal: false,
                },
                organization: {
                    timeZoneId: 39,
                    addressLine1: '',
                    addressLine2: '',
                    town: '',
                    city: '',
                    region: '',
                    country: '',
                    postcode: '',
                    name: '',
                    resellerId: '',
                    modules: [],
                    applyOrganizationTheme: false,
                    createLoginPage: false,
                    smCanSwitchSites: false,
                    dfsSmCanAccessFormsManager: true,
                    dfsBmCanAccessFormsManager: true,
                    dfsSmCanAccessHaccpPolicy: false,
                    icon : null,
                    iconFile: {},
                    logo:  null,
                    logoFile: {},
                    pageFooter: '',
                    colorHeader: '#000000',
                    colorMenu: '#000000',
                    colorFooter: '#000000',
                    accordionModeMainMenu: false,
                    styleLayoutBoxed: false,
                    styleSidebar: 'normal',
                    dfsActive: 'not_exist',
                    complianceActive: 'not_exist',
                    academyActive: 'not_exist',
                    domainName: '',
                },
                academy: {
                    hqManager: ''
                },
                federationToolbar: {
                    hasProvider: false,
                    credentialsPending: false,
                    isEditing: false,
                    saving: false,
                    loading: true,
                },
                federationSummary: {
                    loaded: false,
                    hasProvider: false,
                    credentialsComplete: false,
                    enabled: false,
                },

            }
        },
        methods: {
            onCancel() {
                this.showDeleteModal = false;
            },
            onFederationToolbar(state) {
                if (!state || typeof state !== 'object') {
                    return;
                }
                this.federationToolbar = {
                    hasProvider: Boolean(state.hasProvider),
                    credentialsPending: Boolean(state.credentialsPending),
                    isEditing: Boolean(state.isEditing),
                    saving: Boolean(state.saving),
                    loading: Boolean(state.loading),
                };
            },
            onFederationEditClick() {
                const c = this.$refs.organizationFederationRef;
                if (c && typeof c.startEdit === 'function') {
                    c.startEdit();
                }
            },
            onFederationCancelClick() {
                const c = this.$refs.organizationFederationRef;
                if (c && typeof c.cancelEdit === 'function') {
                    c.cancelEdit();
                }
            },
            onFederationUpdateClick() {
                const c = this.$refs.organizationFederationRef;
                if (c && typeof c.submitUpdate === 'function') {
                    c.submitUpdate();
                }
            },
            actionDelete() {
                this.$api.deleteOrganization({
                    segments: {
                        id: this.$route.params.id,
                    },
                }).then(() => {
                    this.$router.push(this.$enums.RoutePathEnum.ORGANIZATIONS);
                })
            },
            assignFields(data){
                this.organization = data.model;
                this.options = data.options;

                this.academy.hqManager = data.model.hqManager;
                this.$nextTick(() => {
                    if (this.isUpdateMode) {
                        this.syncOrganizationDocumentTitle({ sendPageView: false });
                    }
                });
            },
            syncOrganizationDocumentTitle(options = {}) {
                if (!this.isUpdateMode) {
                    return;
                }
                setEntityEditDocumentTitle(
                    this,
                    this.organization.name,
                    this.$route.params.id,
                    'Organization',
                    options
                );
            },
            actionCancel() {
                this.$router.push(this.$enums.RoutePathEnum.ORGANIZATIONS);
            },
            actionSave() {

                let formData = new FormData();

                for (let key in this.organization) {
                    formData.append(key, this.organization[key]);
                }
                for (let key in this.academy) {
                    formData.append(key, JSON.stringify(this.academy[key]));
                }

                if (this.organization.iconFile) {
                    if (this.organization.iconFile.sourceFile) {
                        formData.append('iconSource', this.organization.iconFile.sourceFile, this.organization.iconFile.name);
                    }
                    if (this.organization.iconFile.targetFile) {
                        formData.append('iconTarget', this.organization.iconFile.targetFile, this.organization.iconFile.name);
                        formData.append('iconData', JSON.stringify(this.organization.iconFile.data));
                    }
                }

                if (this.organization.logoFile) {
                    if (this.organization.logoFile.sourceFile) {
                        formData.append('logoSource', this.organization.logoFile.sourceFile, this.organization.logoFile.name);
                    }
                    if (this.organization.logoFile.targetFile) {
                        formData.append('logoTarget', this.organization.logoFile.targetFile, this.organization.logoFile.name);
                        formData.append('logoData', JSON.stringify(this.organization.logoFile.data));
                    }
                }

                if (this.organization.loginPageBackgroundFile) {
                    if (this.organization.loginPageBackgroundFile.sourceFile) {
                        formData.append('loginPageBackgroundSource', this.organization.loginPageBackgroundFile.sourceFile, this.organization.loginPageBackgroundFile.name);
                    }
                    if (this.organization.loginPageBackgroundFile.targetFile) {
                        formData.append('loginPageBackgroundTarget', this.organization.loginPageBackgroundFile.targetFile, this.organization.loginPageBackgroundFile.name);
                        formData.append('loginPageBackgroundData', JSON.stringify(this.organization.loginPageBackgroundFile.data));
                    }
                }


                if (this.isUpdateMode) {
                    this.settings.loadingOrganization = true;
                    this.$api.organizationUpdate({
                        data: formData,
                        segments: {
                            id: this.$route.params.id
                        },
                        headers: {"content-type": "multipart/form-data"}
                    }).then(({data}) => {
                        this.assignFields(data);
                    }).finally(() => {
                        this.settings.loadingOrganization = false;
                    });
                } else {
                    this.$api.organizationCreate({
                        data: formData,
                        headers: {"content-type": "multipart/form-data"}
                    }).then(() => {
                        this.$router.push(this.$enums.RoutePathEnum.ORGANIZATIONS);
                    });
                }
            },
            loadOrganizationData(){
                this.settings.loadingOrganization = true;
                this.$api.organizationView({
                    segments: {
                        id: this.$route.params.id ?? -1,
                    }
                }).then(({data}) => {
                        this.assignFields(data);
                        this.$nextTick(() => {
                            if (this.isUpdateMode) {
                                this.syncOrganizationDocumentTitle({ sendPageView: true });
                            }
                        });
                }).catch(() => {
                    this.$router.back();
                }).finally(()=>{
                    this.settings.loadingOrganization = false;
                    this.refreshFederationSummary();
                });

            },
            refreshFederationSummary() {
                if (!this.isUpdateMode || !this.$route.params.id) {
                    this.federationSummary = {
                        loaded: false,
                        hasProvider: false,
                        credentialsComplete: false,
                        enabled: false,
                    };
                    return;
                }
                const id = this.$route.params.id;
                this.$api.organizationFederationShow({segments: {organizationId: id}})
                    .then(({data}) => {
                        this.federationSummary = {
                            loaded: true,
                            hasProvider: true,
                            credentialsComplete: data.credentials_complete === true,
                            enabled: data.federation_enabled !== false,
                        };
                    })
                    .catch((err) => {
                        const status = err.response && err.response.status;
                        if (status === 404) {
                            this.federationSummary = {
                                loaded: true,
                                hasProvider: false,
                                credentialsComplete: false,
                                enabled: false,
                            };
                            return;
                        }
                        this.federationSummary = {
                            loaded: true,
                            hasProvider: false,
                            credentialsComplete: false,
                            enabled: false,
                        };
                    });
            },
            onFederationOrgChanged(payload) {
                if (!payload || String(payload.organizationId) !== String(this.$route.params.id)) {
                    return;
                }
                this.refreshFederationSummary();
            },
            loadDefaultPage(){
                if(!this.$route.params.tab || this.$route.params.tab === '') {
                    this.$router.replace(this.generalUrl);
                    return;
                }
                if (!this.isUpdateMode && this.$route.params.tab === 'federation') {
                    this.$router.replace(this.generalUrl);
                }
            },

            ...mapMutations('app', {
                setTitlePage: 'setTitlePage',
            })
        },
        mounted() {
            this.loadOrganizationData();
            this.setTitlePage(this.pageTitle);
            if (this.isUpdateMode) {
                this.syncOrganizationDocumentTitle({ sendPageView: false });
            }
        },
        created() {
           this.loadDefaultPage();
           if (this.$bus) {
               this.$bus.on('organizationFederationChanged', this.onFederationOrgChanged);
           }
        },
        beforeDestroy() {
            if (this.$bus) {
                this.$bus.off('organizationFederationChanged', this.onFederationOrgChanged);
            }
        },
        watch: {
            isUpdateMode() {
                this.federationToolbar = {
                    hasProvider: false,
                    credentialsPending: false,
                    isEditing: false,
                    saving: false,
                    loading: true,
                };
                this.loadOrganizationData();
                this.setTitlePage(this.pageTitle);
                this.loadDefaultPage();
                this.refreshFederationSummary();
            },
            federatedUsersTabVisible(now, prev) {
                if (prev === true && now === false && this.$route.params.tab === 'federation-users') {
                    this.$router.replace(this.generalUrl);
                }
            },
            'organization.name'() {
                if (this.isUpdateMode) {
                    this.syncOrganizationDocumentTitle({ sendPageView: false });
                }
            },
        },
    }
</script>

<style lang="scss">

    .tab-overwrite {
        .md-button:before {
            display: block !important;
        }

        .md-tabs-navigation {
            height: 63px !important;
            padding: 0 5px 0 0 !important;
            overflow-x: auto;
            overflow-y: hidden;
            flex-wrap: nowrap;
            white-space: nowrap;

            .md-tab-nav-button {
                color: rgba(255, 255, 255, 0.5) !important;
            }

            .md-tab-nav-button:hover {
                color: rgba(255, 255, 255, 1) !important;

                .md-icon {
                    color: rgba(255, 255, 255, 1) !important;
                }
            }

            .md-active,
            .md-active:hover,
            .md-active:focus {
                color: rgba(255, 255, 255, 1) !important;
                background-color: transparent !important;
                border-bottom: solid !important;
                box-shadow: none;

                .md-icon {
                    color: rgba(255, 255, 255, 1) !important;
                }
            }

            .md-icon {
                color: rgba(255, 255, 255, 0.5) !important;
            }

            .md-button {
                margin: 0 !important;
                -moz-border-radius: 0 !important;
                -webkit-border-radius: 0 !important;
                border-radius: 0 !important;
            }
        }
    }

    .user-update-actions {
        display: flex;
        justify-content: flex-end;
        flex-wrap: wrap;
        gap: 8px;
    }

</style>
